import { RefundLabelTextHelper } from '../labelTextHelper/RefundLabelTextHelper';
import { HeaderItem } from '../../model/HeaderItem';

// Fields excluded from the import view (not needed for import)
const excludedImportFieldList = ['refundId', 'balanceType', 'dateCreateAt', 'dateModifyAt'];

export const RefundHeaderHelper = {
    // Header items for LIST view (showing individual refund records)
    getHeaderItems(): HeaderItem[] {
        return [
            { text: RefundLabelTextHelper.getLabelText.refundId, value: 'refundId' },
            { text: RefundLabelTextHelper.getLabelText.dateRefundOn, value: 'dateRefundOn', format: 'date' },
            { text: RefundLabelTextHelper.getLabelText.orderNumber, value: 'orderNumber' },
            { text: RefundLabelTextHelper.getLabelText.marketplaceCode, value: 'marketplaceCode' },
            { text: RefundLabelTextHelper.getLabelText.refundType, value: 'refundType' },
            { text: RefundLabelTextHelper.getLabelText.refundAmount, value: 'refundAmount' },
            { text: RefundLabelTextHelper.getLabelText.refundCurrencyCode, value: 'refundCurrencyCode' },
            { text: RefundLabelTextHelper.getLabelText.balanceType, value: 'balanceType' },
            { text: RefundLabelTextHelper.getLabelText.description, value: 'description' },
            { text: RefundLabelTextHelper.getLabelText.reason, value: 'reason' },
            { text: RefundLabelTextHelper.getLabelText.remarks, value: 'remarks' },
            { text: RefundLabelTextHelper.getLabelText.dateCreateAt, value: 'dateCreateAt', format: 'datetime' },
            { text: RefundLabelTextHelper.getLabelText.dateModifyAt, value: 'dateModifyAt', format: 'datetime' }
        ];
    },

    getDateTimePropertyList(): string[] {
        return this.getHeaderItems()
            .filter((item) => item.format === 'datetime')
            .map((item) => item.value);
    },

    getDatePropertyList(): string[] {
        return this.getHeaderItems()
            .filter((item) => item.format === 'date')
            .map((item) => item.value);
    },

    getActionHeaderItem(): HeaderItem {
        return { text: RefundLabelTextHelper.getLabelText.action, value: 'action' };
    },

    getCsvHeader() {
        return [...this.getHeaderItems().map((item) => ({ key: item.value, text: item.text }))];
    },

    getHeaders() {
        return [...this.getHeaderItems(), this.getActionHeaderItem()];
    },

    getImportFields() {
        return this.getFilteredHeaderItems().reduce((acc, item) => {
            acc[item.value] = {
                required: false,
                label: item.text
            };
            return acc;
        }, {} as Record<string, { required: boolean; label: string }>);
    },

    getImportHeaders() {
        return this.getFilteredHeaderItems();
    },

    getFilteredHeaderItems() {
        return this.getHeaderItems().filter((header) => !excludedImportFieldList.includes(header.value));
    }
};
